module.exports = __webpack_public_path__ + "static/media/index-gift-dialog-bottom.b4079d42.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index-gift-dialog-bottom.png
// module id = 1989
// module chunks = 6